module.exports = __webpack_public_path__ + "static/media/VICTORY8.32860f5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/VICTORY8.mp3
// module id = 308
// module chunks = 1 2 3